import * as React from 'react';
import { StickyCallToAction } from '@grandvisionhq/common';
import '../../context/actions.js';
import '../../context/reducer.js';
import { useProductData } from '../../context/product-context-hooks.js';
import '../../context/ProductContext.js';
import '../../context/CmsContext.js';
import { StickyPriceView } from './components/StickyPriceView.js';

const StickyMobileCtaAndPrice = ({ cta , className , priceSubtitle  })=>{
    const { displayPrice  } = useProductData();
    return /*#__PURE__*/ React.createElement(StickyCallToAction, {
        className: className,
        button: cta,
        price: /*#__PURE__*/ React.createElement(StickyPriceView, {
            displayPrice: displayPrice
        }),
        priceSubtitle: priceSubtitle
    });
};

export { StickyMobileCtaAndPrice };
//# sourceMappingURL=StickyMobileCtaAndPrice.js.map
